<template>
    <header class="header-global">
        <base-nav class="navbar-main" transparent type="default" fixed effect="dark" expand>
            <router-link slot="brand" class="navbar-brand ml-xl-2" to="/">
                <img src="img/brand/logo-white.svg" alt="Sessão da Tarde - resgatando o passado da dublagem brasileira">
            </router-link>

            <div class="row" slot="content-header" slot-scope="{closeMenu}">
                <div class="col-6 collapse-brand">
                    <router-link to="/">
                        <img src="img/brand/logo-blue.svg">
                    </router-link>
                </div>
                <div class="col-6 collapse-close">
                    <close-button @click="closeMenu"></close-button>
                </div>
            </div>

            <ul class="navbar-nav flex-fill justify-content-center align-items-lg-center">
                <li class="nav-item">
                    <router-link to="/filmes" class="nav-link nav-link-icon">
                        <i class="fa fa-film d-lg-none"></i>
                        <span class="nav-link-inner--text">Filmes</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/seriados" class="nav-link nav-link-icon">
                        <i class="fa fa-television d-lg-none"></i>
                        <span class="nav-link-inner--text">Seriados</span>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/novidades" class="nav-link nav-link-icon">
                        <i class="fa fa-newspaper-o d-lg-none"></i>
                        <span class="nav-link-inner--text">Novidades</span>
                    </router-link>
                </li>
                <base-dropdown tag="li" class="nav-item">
                    <a slot="title" href="#" v-on:click.prevent class="nav-link nav-link-icon dropdown-toggle" data-toggle="dropdown" role="button">
                        <i class="fa fa-film d-lg-none"></i>
                        <span class="nav-link-inner--text">DublaLândia</span>
                    </a>
                    <router-link to="/dubladores" class="dropdown-item text-default">
                        <i class="fa fa-microphone d-lg-none mr-1"></i>
                        <span class="nav-link-inner--text">Dubladores</span>
                    </router-link>
                    <router-link to="/estudios" class="dropdown-item text-default">
                        <i class="fa fa-language d-lg-none mr-1"></i>
                        <span class="nav-link-inner--text">Estúdios</span>
                    </router-link>
                    <router-link to="/personalidades" class="dropdown-item text-default">
                        <i class="fa fa-users d-lg-none mr-1"></i>
                        <span class="nav-link-inner--text">Personalidades</span>
                    </router-link>                    
                    <div class="dropdown-divider d-lg-none"></div>
                </base-dropdown>
                <li class="nav-item">
                    <router-link to="/sobre" class="nav-link nav-link-icon">
                        <i class="fa fa-info-circle d-lg-none"></i>
                        <span class="nav-link-inner--text">Sobre</span>
                    </router-link>
                </li>
                <li class="nav-item d-lg-none d-xl-block">
                    <router-link to="/como-funciona" class="nav-link nav-link-icon">
                        <i class="fa fa-question-circle d-lg-none"></i>
                        <span class="nav-link-inner--text">Ajuda</span>
                    </router-link>
                </li>
                <li class="nav-item d-lg-none d-xl-block">
                    <router-link to="/contato" class="nav-link nav-link-icon">
                        <i class="ni ni-email-83 d-lg-none"></i>
                        <span class="nav-link-inner--text">Contato</span>
                    </router-link>
                </li>
                <li class="nav-item d-inline d-lg-none">
                    <router-link to="/sacola" class="nav-link nav-link-icon">
                        <i class="ni ni-basket d-lg-none"></i>
                        <span class="nav-link-inner--text">Sacola de Títulos</span>
                    </router-link>
                </li>
                <li class="nav-item d-inline d-lg-none" v-if="!isAuthenticated">
                    <router-link to="/login" class="nav-link nav-link-icon">
                        <i class="fa fa-sign-in"></i>
                        <span class="nav-link-inner--text">Acessar</span>
                    </router-link>
                </li>
                <li class="nav-item d-inline d-lg-none" v-if="isAuthenticated">
                    <router-link to="/perfil" class="nav-link nav-link-icon">
                        <i class="ni ni-circle-08"></i>
                        <span class="nav-link-inner--text">Perfil</span>
                    </router-link>
                </li>
                <li class="nav-item d-inline d-lg-none" v-if="isAuthenticated">
                    <router-link to="/logout" class="nav-link nav-link-icon">
                        <i class="ni ni-button-power"></i>
                        <span class="nav-link-inner--text">Sair</span>
                    </router-link>
                </li>
            </ul>
            <auth-modal-component></auth-modal-component>
        </base-nav>
    </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

import AuthModalComponent from "./components/Auth/AuthModalComponent";

import { mapGetters } from 'vuex';

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
    AuthModalComponent
  },
  computed: mapGetters('auth', [
    'isAuthenticated',
  ]),
  methods: {}
};
</script>
<style>
</style>
